import { isAndroid } from "features/common/utils/functions/mobile";
import { getFeatureFlag } from "features/feature-flags";

import { usePushNotificationsContext } from "../context";

export default function useArePushNotificationsSupported() {
  const context = usePushNotificationsContext();
  const pushNotificationsFlag = getFeatureFlag("pushNotifications");

  return !!(
    context.ready &&
    context.firebaseMessagingIsSupported &&
    (pushNotificationsFlag || isAndroid())
  );
}
